module.exports = __webpack_public_path__ + "static/media/primary.0657bbb9.jpg";